var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorrection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_399_32236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 18C8.691 18 6 15.309 6 12C6 8.691 8.691 6 12 6C15.309 6 18 8.691 18 12C18 15.309 15.309 18 12 18ZM12 7C9.243 7 7 9.243 7 12C7 14.757 9.243 17 12 17C14.757 17 17 14.757 17 12C17 9.243 14.757 7 12 7Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9994 14.5C13.8954 14.5 13.7894 14.467 13.6994 14.4L11.6994 12.9C11.5734 12.806 11.4994 12.657 11.4994 12.5V9.5C11.4994 9.224 11.7234 9 11.9994 9C12.2754 9 12.4994 9.224 12.4994 9.5V12.25L14.2994 13.6C14.5204 13.766 14.5654 14.079 14.4004 14.3C14.3014 14.431 14.1504 14.5 13.9994 14.5Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.77 15C0.541 15 0.334 14.842 0.282 14.609C0.095 13.778 0 12.899 0 12C0 5.383 5.383 0 12 0C15.754 0 19.22 1.711 21.507 4.696C21.675 4.915 21.634 5.229 21.414 5.397C21.197 5.564 20.881 5.524 20.714 5.304C18.616 2.569 15.44 1 12 1C5.935 1 1 5.935 1 12C1 12.826 1.087 13.63 1.258 14.391C1.319 14.66 1.149 14.928 0.879 14.988C0.842 14.996 0.806 15 0.77 15Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 24.0001C8.24536 24.0001 4.77936 22.2891 2.49236 19.3041C2.32436 19.0851 2.36536 18.7711 2.58536 18.6031C2.80036 18.4361 3.11836 18.4761 3.28536 18.6961C5.38336 21.4311 8.55936 23.0001 11.9994 23.0001C18.0644 23.0001 22.9994 18.0651 22.9994 12.0001C22.9994 11.1611 22.9094 10.3591 22.7324 9.61609C22.6684 9.34709 22.8344 9.07809 23.1024 9.01409C23.3734 8.95009 23.6404 9.11609 23.7054 9.38509C23.9004 10.2031 23.9994 11.0831 23.9994 12.0001C23.9994 18.6171 18.6164 24.0001 11.9994 24.0001Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55038 24C2.27638 24 2.05338 23.779 2.05038 23.505L2.00038 18.505C1.99938 18.372 2.05138 18.243 2.14538 18.149C2.23838 18.053 2.36638 18 2.50038 18H7.50038C7.77638 18 8.00038 18.224 8.00038 18.5C8.00038 18.776 7.77638 19 7.50038 19H3.00538L3.05038 23.495C3.05338 23.771 2.83138 23.997 2.55538 24C2.55338 24 2.55238 24 2.55038 24Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4994 6H16.4994C16.2234 6 15.9994 5.776 15.9994 5.5C15.9994 5.224 16.2234 5 16.4994 5H20.9994V0.5C20.9994 0.224 21.2234 0 21.4994 0C21.7754 0 21.9994 0.224 21.9994 0.5V5.5C21.9994 5.776 21.7754 6 21.4994 6Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_399_32236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrection);
export default __webpack_public_path__ + "static/media/correction.0fd19fbfdb42a23a11c33ce98d0b683d.svg";
export { ForwardRef as ReactComponent };